module.exports = __webpack_public_path__ + "img/br15.df01bd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br15.jpg
// module id = cG9r
// module chunks = 0